import React, { lazy } from 'react';
const pillars = [{
  letter: 'B',
  title: 'Biociclo de Sueño',
  description: 'Sincronización hormonal para consolidar 7-10 horas de sueño profundo'
}, {
  letter: 'E',
  title: 'Estimulación Activa',
  description: 'Micro-acciones de 5 min para disparar el CI y la conexión cognitiva'
}, {
  letter: 'B',
  title: 'Bio-Nutrición',
  description: 'El mapa de combustible evolutivo para construir un cerebro de élite'
}, {
  letter: 'E',
  title: 'Equilibrio Autónomo',
  description: 'El protocolo para que tu bebé aprenda la autorregulación'
}];
export function SolutionSection() {
  return <section id="solution" className="bg-gradient-to-br from-[#3D2B1F] to-[#6B4C3B] text-[#FAF7F2] py-16 px-5" data-id="element-352">
      <div className="max-w-[900px] mx-auto" data-id="element-353">
        <div className="text-center mb-2.5" data-id="element-354">
          <span className="inline-block bg-white/10 text-[#C9A96E] text-xs tracking-widest uppercase px-4 py-1.5 rounded-full font-sans font-bold" data-id="element-355">
            La Solución
          </span>
        </div>

        <h2 className="text-3xl md:text-4xl text-[#FAF7F2] mb-4 leading-tight text-center" data-id="element-356">
          El Protocolo B.E.BE 365
        </h2>

        {/* Mobile-only emotional image */}
        <img src="https://cdn.shopify.com/s/files/1/0981/0781/8286/files/Bebe_jugando_con_juguete_de_madera.png?v=1775551272" alt="Bebé jugando con juguete de madera" width="450" height="450" loading="lazy" decoding="async" className="md:hidden w-[90%] max-w-[450px] mx-auto mb-6 block rounded-3xl shadow-[0_10px_30px_rgba(61,43,31,0.08)] border border-[rgba(183,110,121,0.1)]" style={{
        aspectRatio: '1/1'
      }} data-id="element-357" />

        <p className="text-lg text-[rgba(250,247,242,0.7)] text-center max-w-[650px] mx-auto mb-12 italic" data-id="element-358">
          4 pilares de ingeniería biológica para el primer año de vida
        </p>

        <div className="grid md:grid-cols-4 gap-6" data-id="element-359">
          {pillars.map((pillar, idx) => <div key={idx} className="bg-white/5 rounded-2xl p-6 text-center border border-white/10 transition-all hover:bg-[rgba(183,110,121,0.2)] hover:-translate-y-1" data-id="element-360">
              <div className="text-5xl font-bold text-[#B76E79] leading-none mb-2.5" data-id="element-361">
                {pillar.letter}
              </div>
              <h3 className="text-base text-[#FAF7F2] mb-2" data-id="element-362">{pillar.title}</h3>
              <p className="text-base text-[rgba(250,247,242,0.7)] font-sans" data-id="element-363">
                {pillar.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}